import { useContext } from 'react';

import { MeterBarChartTooltipContext } from '../../context/MeterBarChartTooltipContext.js';

export const useSetState = () => {
  const { setState } = useContext(MeterBarChartTooltipContext);

  return setState;
};
